import axios from "axios";

export const BACKEND = process.env.REACT_APP_BACKEND_URL;
export const WS_KEY = "mh-ws";
export const getWs = () => localStorage.getItem(WS_KEY) || "";

export const http = axios.create({ baseURL: `${BACKEND}/api`, withCredentials: true });

http.interceptors.request.use((cfg) => {
  const ws = getWs();
  if (ws) cfg.headers["X-Workspace-Id"] = ws;
  // CSRF double-submit: on cookie-authenticated state-change calls, echo the csrf_token
  // value back as the X-CSRF-Token header. We prefer localStorage (populated from the
  // login response body) because mobile Safari with Partitioned cookies hides the cookie
  // value from document.cookie even though the browser still sends it. Fall back to the
  // cookie if localStorage is empty.
  const method = (cfg.method || "get").toLowerCase();
  if (["post", "put", "patch", "delete"].includes(method)) {
    let csrf = localStorage.getItem("csrf_token");
    if (!csrf) csrf = document.cookie.split("; ").find((r) => r.startsWith("csrf_token="))?.split("=")[1];
    if (csrf) cfg.headers["X-CSRF-Token"] = csrf;
  }
  return cfg;
});

let refreshing = null;
http.interceptors.response.use(
  (r) => r,
  async (err) => {
    const cfg = err.config || {};
    const url = cfg.url || "";
    if (err.response?.status === 401 && !cfg._retry && !url.includes("/auth/")) {
      cfg._retry = true;
      try {
        refreshing = refreshing || http.post("/auth/refresh").finally(() => { refreshing = null; });
        await refreshing;
        return http(cfg);
      } catch {
        window.dispatchEvent(new Event("mh-logout"));
      }
    }
    return Promise.reject(err);
  }
);

export function errText(e, fallback = "Something went wrong. Please try again.") {
  const d = e?.response?.data?.detail;
  if (!d) return e?.message || fallback;
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((x) => x?.msg || JSON.stringify(x)).join(" ");
  return d.msg || String(d);
}

export function copyText(text) {
  try {
    const p = navigator.clipboard?.writeText(text);
    if (p && p.catch) p.catch(() => fallbackCopy(text));
    else fallbackCopy(text);
  } catch {
    fallbackCopy(text);
  }
}

function fallbackCopy(text) {
  const ta = document.createElement("textarea");
  ta.value = text;
  ta.style.position = "fixed";
  ta.style.opacity = "0";
  document.body.appendChild(ta);
  ta.select();
  try { document.execCommand("copy"); } catch {}
  ta.remove();
}
